import React, { useCallback, useEffect, useState } from 'react';
import * as Yup from 'yup';

import Switch from '../../../../../../newComponents/Switch';
import Input from '../../../../../../newComponents/UnformInput';

import moneyMask from '../../../../../../utils/moneyMask';
import getNumberValue from '../../../../../../utils/getNumberValue';

import { useSimpleProduct } from '../../../../../../hooks/simpleProduct';

import { Container, SaleContainer } from './styles';

export const PriceFormSchema = Yup.object().shape({
  price: Yup.number()
    .min(0.01, 'Preço inválido')
    .required('O preço é obrigatório'),
  sale: Yup.number()
    .min(0.01, 'Novo preço inválido')
    .required('O desconto é obrigatório'),
  discount: Yup.number()
    .integer('Desconto inválido')
    .min(0, 'Desconto inválido')
    .max(99.99, 'Desconto inválido')
    .required('O desconto é obrigatório'),
});

const Price: React.FC = () => {
  const {
    hasDiscount,
    isDrawerOpened,
    price: defaultPrice,
    newPrice: defaultNewPrice,
    handleChangeProduct,
  } = useSimpleProduct();

  const [price, setPrice] = useState('R$ 0,00');
  const [sale, setSale] = useState('R$ 0,00');
  const [discount, setDiscount] = useState(0);

  const handleHasDiscountChange = useCallback(
    (value: boolean) => {
      handleChangeProduct({ hasDiscount: value });
    },
    [handleChangeProduct],
  );

  useEffect(() => {
    setPrice(moneyMask(parseFloat(String(defaultPrice)).toFixed(2)));
    setSale(moneyMask(parseFloat(String(defaultNewPrice)).toFixed(2)));
    setDiscount(
      Math.round(
        ((defaultPrice - defaultNewPrice) / (defaultPrice || 1)) * 100,
      ),
    );
  }, [defaultPrice, defaultNewPrice, isDrawerOpened]);

  return (
    <Container>
      <Input
        id="price"
        name="price"
        label="Preço"
        step={1}
        value={price}
        onChange={(event) => {
          const { value } = event.target;

          setPrice(moneyMask(value));
          setSale(
            moneyMask(
              (
                getNumberValue(moneyMask(value)) -
                getNumberValue(moneyMask(value)) * (Number(discount) / 100)
              ).toFixed(2),
            ),
          );
        }}
      />
      <SaleContainer>
        <div className="header">
          <h2>Desconto</h2>
          <Switch
            checked={hasDiscount}
            onChange={handleHasDiscountChange}
            height={24}
            width={48}
            handleDiameter={15}
          />
        </div>
        <div className="inputs">
          <Input
            id="sale"
            name="sale"
            label="Novo preço"
            step={1}
            disabled={!hasDiscount}
            value={sale}
            onChange={(event) => {
              const { value } = event.target;

              setSale(moneyMask(value));
              setDiscount(
                Math.round(
                  ((getNumberValue(price) - getNumberValue(value)) /
                    getNumberValue(price)) *
                    100,
                ),
              );
            }}
          />
          <Input
            suffix="%"
            id="discount"
            name="discount"
            label="Desconto"
            disabled={!hasDiscount}
            value={discount}
            onChange={(event) => {
              const { value } = event.target;

              let finalValue = Number(value.replace(/\D/g, ''));

              if (isNaN(Number(value.replace(/\D/g, '')))) {
                finalValue = 0;
              }

              setDiscount(Number(finalValue));
              setSale(
                moneyMask(
                  String(
                    (
                      getNumberValue(price) -
                      getNumberValue(price) * (Number(finalValue) / 100)
                    ).toFixed(2),
                  ),
                ),
              );
            }}
          />
        </div>
      </SaleContainer>
    </Container>
  );
};

export default Price;
